.content {
  font-size: 1.6rem;
  font-weight: 400;
  line-height: 2.4rem;
  color: var(--color-grayscale-light-slate);
  white-space: pre-line;

  @media screen and (min-width: $bp-medium) {
    max-width: 38rem;
  }
}

.checkbox-container {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: 1.6rem;
  align-self: flex-start;

  @media screen and (min-width: $bp-small) {
    margin-top: unset;
  }

  button {
    all: unset;
  }

  .checkbox-root {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 1.1rem;
    height: 1.1rem;
    background-color: transparent;
    border-radius: 1px;
    box-shadow: 0 0 0 1px var(--color-primary-crayola);
  }

  .checkbox-indicator {
    position: absolute;
    top: -2px;
    left: -2px;
    width: 5.13px;
    height: 4.75px;
    color: var(--color-primary-crayola);
  }

  label {
    color: var(--color-grayscale-light-slate);
    font-weight: 300;
    font-size: 1.4rem;
    line-height: 2rem;
    user-select: none;
  }

  @media screen and (min-width: $bp-small) {
    align-self: unset;
  }
}
